<template>
  <div class="recruitment-status-modal">
    <v-dialog
      v-model="isVisible"
      max-width="400"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title
          class="recruitment-status-modal__title headline"
          primary-title
        >
          RECRUITMENT STATUS
          <v-btn icon large color="primary" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pb-0">
          <v-row>
            <v-col>
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
              sed diam nonumy eirmod tempor invidunt.
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <label v-for="(status, index) in recruitmentStatuses"
                :key="index"
                class="status-select"
                v-ripple
              >
                <input
                  v-model="currentStatusValue"
                  class="status-select__radio"
                  type="radio"
                  :value="status"
                  name="status-select"
                />
                <div :class="['status-select__option',
                  `status-select__option--${serializedStatus(status)}`]"
                >
                  <span>{{ status }}</span>
                  <span class="status-select__check">
                    <v-icon color="white" size="12">mdi-check</v-icon>
                  </span>
                </div>
              </label>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="recruitment-status-modal__actions">
          <v-btn
            class="recruitment-status-modal__submit"
            color="blue"
            large
            depressed
            :loading="processing"
            @click="submit"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const recruitmentStatuses = ['ASAP', 'Urgent', 'Basic'];

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    processing: {
      type: Boolean,
      required: false,
      default: false,
    },
    recruitment: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      recruitmentStatuses,
      currentStatusValue: '',
    };
  },

  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  watch: {
    isVisible() {
      this.currentStatusValue = this.recruitment.status;
    },
  },

  methods: {
    closeModal() {
      this.$emit('input', false);
    },

    submit() {
      const recruitmentStatus = {
        id: this.recruitment.id,
        status: this.currentStatusValue,
      };

      this.$emit('submit', recruitmentStatus);
    },

    serializedStatus(status) {
      return status.replace(/ /g, '').toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.recruitment-status-modal {
  &__title {
    display: flex;
    justify-content: space-between;
    font-weight: 600 !important;
    font-size: 22px !important;
  }

  &__actions {
    padding: 0 24px 16px 24px;
  }

  &__submit {
    font-weight: 400;
    color: white;
    width: 256px;
  }
}

.status-select {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 4px;
  margin-bottom: 8px;
  display: block;
  text-transform: capitalize;
  cursor: pointer;

  &__radio {
    opacity: 0;
    position: absolute;

    &:checked ~ .status-select__option {
      background-color: $color--green;
      border-color: $color--green;
      color: #fff;

      &.status-select__option--basic {
        background-color: $color--green--light;
        border-color: $color--green--light;
        color: $color--green;

        .status-select__check {
          background-color: $color--green;
          border-color: $color--green;
        }
      }

      &.status-select__option--asap {
        background-color: $color--red-light;
        border-color: $color--red-light;
        color: $color--red;

        .status-select__check {
          background-color: $color--red;
          border-color: $color--red;
        }
      }

      &.status-select__option--urgent {
        background-color: $color--yellow-light;
        border-color: $color--yellow-light;
        color: $color--yellow;

        .status-select__check {
          background-color: $color--yellow;
          border-color: $color--yellow;
        }
      }
    }
  }

  &__option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border-radius: 4px;
    border: 1px solid #E2E6EA;
  }

  &__check {
    width: 20px;
    height: 20px;
    display: inline-block;
    border: 1px solid #E2E6EA;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
